import { FC, useMemo } from 'react'
import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'
import { useNotificationsList } from 'services/notifications/notifications.hook'

// Board message detail ("Panel Klienta 3.0" Komunikaty — Wiadomości).
const BoardsMessage: FC = () => {
  const { messagesList } = useNotificationsList()
  const { formatMessage } = useIntl()
  const { id } = useParams()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const navigate = useNavigate()

  const message = useMemo(
    () => messagesList.find((meg) => meg.id === Number(id)),
    [messagesList, id]
  )

  if (message) {
    const title =
      message.subject ??
      formatMessage({ id: 'moardsMessage.title', defaultMessage: 'Wiadomość {id}' }, { id })

    if (isDesktop) {
      return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', mb: '20px' }}>
            <IconButton
              onClick={() => navigate('/board')}
              sx={{ width: '36px', height: '36px', color: theme.r4r.navy, borderRadius: 0 }}>
              <ArrowBack sx={{ fontSize: '22px' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: '28.8px',
                color: theme.r4r.navy
              }}>
              {formatMessage({ id: 'boardsMessagesPage.label', defaultMessage: 'Wiadomości' })}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: '#fff',
              boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.06)',
              padding: '32px 36px 48px'
            }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 800,
                lineHeight: '31.2px',
                color: theme.r4r.navy
              }}>
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: '13px',
                color: theme.r4r.grey,
                mt: '8px',
                pb: '21px',
                mb: '16px',
                borderBottom: `1px solid ${theme.r4r.greyLight}`
              }}>
              {dayjs(message.createDate).format('DD/MM/YYYY HH:mm')}
            </Typography>
            <Typography
              component='div'
              sx={{ width: '100%', overflow: 'auto', fontSize: '14px', color: theme.r4r.ink }}
              dangerouslySetInnerHTML={{ __html: message.renderedEmail }}
            />
          </Box>
        </>
      )
    }

    return (
      <>
        <BackNavigationHeader navigateTo='/board' label={title} />
        <BackNavigationContent>
          <Typography sx={{ fontSize: '20px', fontWeight: 700, color: theme.r4r.navy }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: '13px', color: theme.r4r.grey, mt: '4px', mb: '16px' }}>
            {dayjs(message.createDate).format('DD/MM/YYYY HH:mm')}
          </Typography>
          <Typography
            component='div'
            sx={{ width: '100%', overflow: 'auto', fontSize: '14px', color: theme.r4r.ink }}
            dangerouslySetInnerHTML={{ __html: message.renderedEmail }}
          />
        </BackNavigationContent>
      </>
    )
  }
  return null
}

export default BoardsMessage
